import { Language } from 'aem-libs-react-ts/src/types/common'

export default (): Language => {
  return document.querySelector('html[lang="en"]') ? 'en' : 'cs'
}
